function MainComponent() {

    document.title = "NEC ファーストコンタクトセンターにおける個人情報の取扱いについて| ファーストコンタクトセンター";
    const imageUrl = require("../../images/popup.png");
    const styleListIl = {
        listStyleType: "decimal"
    };
    return (
        <>
            <div className="header-utility">
                <div className="header-utility-inner">
                    <ul className="header-utility-list sub">
                    </ul>
                </div>
            </div>
            <main className="site-main">
                <section className="sct-primary">
                    <div className="str-outer-wide">
                        <div className="str-inner">
                            <div className="mod-hdg-l1">
                                <div className="inner">
                                    <h1 className="hdg">Web問い合わせシステム</h1>
                                    <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                                </div>
                            </div>
                            <h2 className="mod-hdg-l2-02">
                                <span>NEC ファーストコンタクトセンターにおける個人情報の取扱いについて</span>
                            </h2>
                            <div className="mod-txt" style={{ margin: "0px" }}>
                                <p style={{ textAlign: "center" }}>NEC ファーストコンタクトセンターにおける個人情報の取扱いについて</p>
                            </div>
                            <div className="mod-txt" >
                                <div style={
                                    {
                                        position: "inherit",
                                        textAlign: "right",
                                        width: "40%",
                                        marginLeft: "60%"
                                    }
                                }>
                                    <div>
                                        <p style={{ margin: "0px" }}>個人情報を取得させていただく事業者</p>
                                        <p style={{ margin: "0px" }}>日本電気株式会社</p>
                                        <p style={{ margin: "0px" }}>個人情報保護管理者</p>
                                        <p style={{ margin: "0px" }}>（職名）日本電気株式会社 クラウド・マネージドサービス事業部門長</p>
                                        <p style={{ margin: "0px" }}>（連絡先）下記「７．本件に関する問い合わせ先」</p>
                                    </div>
                                </div>
                            </div>

                            <div className="mod-txt" style={{ margin: "0px" }}>
                                <p style={{ margin: "0px" }}>NEC ファーストコンタクトセンター（以下「当センター」）にご提供いただきました個人情報に関しましては、日本電気株式会社<img src={imageUrl} alt="popup" className="icn" lang="en" /><a href="https://jpn.nec.com/site/privacy/index.html" target="_blank" rel="noreferrer">個人情報保護</a>と、以下に基づき、適切な管理に努めてまいります。</p>
                            </div>

                            <div className="mod-txt">
                                <ol style={{ paddingLeft: "20px" }}>
                                    <li style={styleListIl}>
                                        利用目的
                                    </li>
                                    <div>
                                        ご提供いただいた個人情報は、以下の目的に利用します。
                                    </div>
                                    <ul>
                                        <li>・お客様からのお問い合わせ/ご相談への対応</li>
                                        <li>・各種情報の提供（DM、E-mail、電話等）</li>
                                        <li>・製品やサービス改善に向けた活動</li>
                                        <li>
                                            <div>
                                                ・ソリューション提案／サービス改善に向けた活動
                                            </div>
                                            <div>
                                                　（お客様ニーズの分析、商品・サービスの開発、評価収集・分析、提案活動、アンケート収集 等）
                                            </div>
                                        </li>
                                    </ul>
                                    <li style={styleListIl}>個人情報の取扱いの委託</li>
                                    <div>
                                        上記利用目的で、NECグループ会社およびパートナー企業に委託する場合があります。
                                    </div>
                                    <li style={styleListIl}>
                                        個人情報の第三者提供
                                    </li>
                                    <div>
                                        個別に同意を頂いた場合または法令等に特段の定めがある場合を除き第三者への提供はいたしません。
                                    </div>
                                    <li style={styleListIl}>
                                        個人情報の共同利用
                                    </li>
                                    <div>
                                        提供いただきましたお客様の個人情報はNECパーソナルコンピュータ株式会社と共同して利用することがあります。共同利用開始日：2025年4月1日
                                    </div>
                                    <div>
                                        共同して利用される個人情報の項目、利用目的などは以下の通りです。
                                    </div>
                                    <div>
                                        （１）共同して利用される個人情報の項目
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;氏名、会社名、所属部署名、メールアドレス、電話番号
                                    </div>
                                    <div>
                                        （２）共同して利用する者の範囲
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;NECパーソナルコンピュータ株式会社（ビジネスPC製品お問い合わせ窓口）
                                    </div>
                                    <div>
                                    （３）共同して利用する者の利用目的
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;・お客様からのビジネスPC製品に関するお問い合わせ/ご相談への対応
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;・ビジネスPC製品に関する製品やサービス改善に向けた活動
                                    </div>
                                    <div>
                                    （４）共同して利用する個人情報の管理について責任を有する者
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日本電気株式会社
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;クラウド・マネージドサービス事業部門長
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;〒108-8001 東京都港区芝五丁目7番1号 NEC本社ビル
                                    </div>
                                    <div>
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;代表者：取締役 代表執行役社長 兼 CEO 森田隆之
                                    </div>
                                    <li style={styleListIl}>
                                        必須項目の入力について
                                    </li>
                                    <div>
                                        当センターの各種お手続きで「【必須】印」が付いた項目は、問い合わせの対応や技術支援のために必須です。必ずご入力ください。入力いただけない場合は、お手続きができない場合がありますのでご了承ください。
                                    </div>
                                    <li style={styleListIl}>
                                        安全管理措置
                                    </li>
                                    <div>
                                        いただきましたお客様の個人情報は、暗号化およびアクセス制限等の安全管理措置を施し、適切に管理させていただきます。
                                    </div>
                                    <li style={styleListIl}>
                                        本件に関する問い合わせ先
                                    </li>
                                    <div>
                                        お客様から提供いただいた個人情報は、Web問い合わせシステムにログインしていただくことで、内容の確認、訂正をすることができます。但し、Partner's BridgeまたはDWPより連携している項目につきましては、Partner's BridgeまたはDWPの情報を更新してください。
                                    </div>
                                    <div>
                                        また、今後お客様ご本人からの要望で、開示、削除、訂正、利用停止等の必要が生じた場合には、お客様ご本人からの連絡をいただくことにより、合理的な範囲で対応いたします。
                                    </div>
                                    <div>
                                        NEC ファーストコンタクトセンター
                                    </div>
                                    <div>
                                        E-mail：fcc-web@pfb.jp.nec.com
                                    </div>
                                    <li style={styleListIl}>
                                        クッキーの利用について
                                    </li>
                                    <div>
                                        <p>
                                            Web問い合わせシステムでは、ページ間の連携をスムーズに行うために、クッキーを利用しています。また、セキュリティ保護のためSSL(暗号化通信)を使用しています。
                                        </p>
                                    </div>
                                    <li style={styleListIl}>
                                        当センターに組み込まれた外部サービスの活用
                                    </li>
                                    <div>
                                        <p>
                                            当センターでは、以下のサービスを用いて、メール送付および行動情報の収集、記録、分析を行います。以下のサービスで分析した結果を確認し、ソリューション提案 ／サービス改善に向けた活動に活用します。
                                        </p>
                                    </div>
                                    <div className="mod-tbl-form">
                                        <table role="presentation">
                                            <colgroup>
                                                <col className="w-10" />
                                                <col />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <td className="caption">
                                                        <div className="inner">
                                                            <b>No.</b>
                                                        </div>
                                                    </td>
                                                    <td className="caption">
                                                        <div className="inner">
                                                            <b>利用サービス名（提供会社）</b>
                                                        </div>
                                                    </td>
                                                    <td className="caption">
                                                        <div className="inner">
                                                            <b>利用規約</b>
                                                        </div>
                                                    </td>
                                                    <td className="caption">
                                                        <div className="inner">
                                                            <b>プライバシーポリシー</b>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody>
                                                <tr>
                                                    <td>1</td>
                                                    <td>Marketing Cloud Account Engagement(Salesforce, Inc.)</td>
                                                    <td>
                                                        <img src={imageUrl} alt="popup" className="icn" lang="en" /><a href="https://www.salesforce.com/content/dam/web/en_us/www/documents/legal/salesforce_MSA-jp.pdf" target="_blank" rel="noreferrer">https://www.salesforce.com/content/dam/web/en_us/www/documents/legal/salesforce_MSA-jp.pdf</a>
                                                    </td>
                                                    <td>
                                                        <img src={imageUrl} alt="popup" className="icn" lang="en" /><a href="https://www.salesforce.com/jp/company/privacy/full_privacy" target="_blank" rel="noreferrer">https://www.salesforce.com/jp/company/privacy/full_privacy/</a>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </ol>
                            </div>
                            <div className="mod-btn of-no-arrow">
                                <div className="btn">
                                    <button onClick={() => { window.close() }}>
                                        閉じる
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </main>
        </>
    );
}


export default MainComponent;